export const calculateDiscountRate = (price: number, specialPrice: number) => {
  if (price <= 0 || specialPrice <= 0) {
    return 0;
  }

  if (specialPrice >= price) {
    return 0;
  }

  const discount = ((price - specialPrice) / price) * 100;
  return Math.round(discount);
};
